import React from 'react';
import { frames } from '../../../../Styles';
import PageHeader from '../../../../Components/BaseComponents/pageHeader';
import { useTranslation } from 'react-i18next';
import { Pages } from '../../../../Navigation/Routers/root';

export default function SilosSettings() {
  const {t} = useTranslation()
  
  return (
    <frames.Page_inner>
    <frames._page_inner_header>
      <PageHeader topHeader={t(`menuHeaders.${Pages.silos}`, {defaultValue: "silos"})} subHeader={t(`menuHeaders.${Pages.silosSettings}`, {defaultValue: "silo settings"})}/>
    </frames._page_inner_header>
    <frames._page_inner_content>
    </frames._page_inner_content>
    </frames.Page_inner>
  );
}